/**
 * admin/sync.tsx — Registry sync panel surface.
 *
 * Lives at `/admin/sync`. Auth-gated to admins. Renders <SyncPanel>.
 */

import type { ReactNode } from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { PageHeader } from '../../components/ui/PageHeader.js';
import { SyncPanel } from '../../components/admin/SyncPanel.js';
import {
  freshSessionQuery,
  syncRunsQuery,
  syncStatusQuery,
  type SessionPrincipal,
} from '../../lib/api/queries.js';

export const Route = createFileRoute('/admin/sync')({
  beforeLoad: async ({ context, location }) => {
    const session = await context.queryClient.fetchQuery(freshSessionQuery);
    const user = session?.ok ? (session.data?.user ?? null) : null;
    if (!user) {
      throw redirect({
        to: '/login',
        search: { error: undefined, redirect: location.href },
      });
    }
    if (user.role !== 'admin') {
      throw redirect({ to: '/' });
    }
    return null;
  },
  loader: async ({ context }) => {
    await context.queryClient.prefetchQuery(syncStatusQuery);
    await context.queryClient.prefetchQuery(syncRunsQuery);
    return null;
  },
  component: AdminSyncPage,
});

function AdminSyncPage(): ReactNode {
  return (
    <main className="page-shell" data-testid="admin-sync-page">
      <PageHeader
        eyebrow="Operasional"
        title="Sinkronisasi registry"
        description="Pantau dan picu sinkronisasi antara katalog di `coding-games` dan storage R2 portal."
      />
      <section className="section">
        <SyncPanel />
      </section>
    </main>
  );
}
